import { NavLink, Outlet, useParams } from 'react-router-dom';
import { Layout, Typography } from 'antd';
import {
  IdcardOutlined, MessageOutlined, PhoneOutlined, UserOutlined,
} from '@ant-design/icons';

/**
 * Front desk / gate kiosk surface — two tabs (visitors + gate passes).
 */
export function FrontDeskShell() {
  const { institution = '' } = useParams<{ institution: string }>();
  return (
    <Layout style={{ minHeight: 'calc(100vh - 50px)', background: '#f7f7f5' }}>
      <Layout.Content style={{ padding: '18px 18px 74px', maxWidth: 1000, margin: '0 auto', width: '100%' }}>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text type="secondary" style={{ fontSize: 11, letterSpacing: 0.4, textTransform: 'uppercase', fontWeight: 600 }}>
            Front desk
          </Typography.Text>
        </div>
        <Outlet />
      </Layout.Content>
      <nav
        style={{
          position: 'fixed', bottom: 0, left: 0, right: 0,
          display: 'flex', justifyContent: 'space-around',
          background: '#fff', borderTop: '1px solid #e6e6e9',
          padding: '8px 0', zIndex: 100,
        }}
      >
        <TabItem to={`/i/${institution}/desk`} end icon={<UserOutlined />} label="Visitors" />
        <TabItem to={`/i/${institution}/desk/gate-passes`} icon={<IdcardOutlined />} label="Gate passes" />
        <TabItem to={`/i/${institution}/desk/inquiries/new`} icon={<MessageOutlined />} label="Walk-in" />
        <TabItem to={`/i/${institution}/desk/calls`} icon={<PhoneOutlined />} label="Calls" />
      </nav>
    </Layout>
  );
}

function TabItem({ to, icon, label, end }: { to: string; icon: React.ReactNode; label: string; end?: boolean }) {
  return (
    <NavLink
      to={to}
      end={end}
      style={({ isActive }) => ({
        display: 'flex', flexDirection: 'column', alignItems: 'center',
        gap: 2, textDecoration: 'none',
        color: isActive ? '#2f6ab0' : '#5b6478',
        fontSize: 11, fontWeight: isActive ? 600 : 500,
      })}
    >
      <span style={{ fontSize: 20 }}>{icon}</span>
      {label}
    </NavLink>
  );
}
